<template>
  <section v-if="!is_load_status" class="z-card outgoing-call-recording pb-3 mt-3 w-50">
    <checkbox
      v-model="record_outgoing"
      :disabled="!is_allowed_record"
      class="outgoing-call-recording__checkbox"
      @click.prevent.native="switchOutgoingCallRecording(record_outgoing)"
    >
      <div class="outgoing-call-recording__title">
        {{ $t('pbx.setting.record_outgoing.title') }}
      </div>
    </checkbox>
    <template v-if="!is_allowed_record">
      <div class="alert alert-warning mt-1 d-flex align-items-center">
        <icon size="24" type="ios-alert-outline" class="mr-1" />
        <div>
          {{ $t('pbx.setting.record_outgoing.warning_text') }}
          <router-link :to="{ name: 'pbx.service-package.index' }">
            {{ $t('pbx.setting.record_outgoing.warning_link_text') }}
          </router-link>
          {{ $t('pbx.setting.record_outgoing.warning_text_end') }}
        </div>
      </div>
    </template>
  </section>
</template>

<script>
  import { ClientConfigService } from '@core/services/ClientConfigService';
  import { SettingsModalService } from '@pbx/modals/SettingsModalService';

  export default {
    data: () => ({
      record_outgoing: false,
      is_load_status: true
    }),
    computed: {
      is_allowed_record() {
        const user = this.$user;
        if (user && user.pbx) {
          return user.pbx.record;
        }
        return false;
      }
    },
    mounted() {
      this.is_load_status = true;
      ClientConfigService.getConfig()
        .then(data => {
          this.record_outgoing = data.record_outgoing || false;
        })
        .finally(() => {
          this.is_load_status = false;
        });
    },
    methods: {
      switchOutgoingCallRecording(value) {
        if (!this.is_allowed_record) return false;

        SettingsModalService.switchOutgoingCallRecording({ is_record: !value })
          .on('success', () => {
            this.record_outgoing = !value;
          })
          .on('cancel', () => {
            this.record_outgoing = value;
          });
      }
    }
  };
</script>
<style lang="scss">
  .outgoing-call-recording {
    &__title {
      margin-left: 12px;
    }
    &__checkbox {
      display: flex;
      align-items: center;
    }
  }
</style>
